<template>
    <nav class="navbar navbar-expand-lg fixed-top" :class="[{'bg-flow shadow navbar-dark' : scrolled}, url || window.width <= 992 ? 'navbar-dark' : 'navbar-light', window.width <= 992 ? 'bg-flow' : '']"  :v-on="handleScroll" id="mynavbar">
        <div class="container py-3">
            <router-link class="navbar-brand" :to="{ name: 'index' }">
              <img :src="require('@/assets/images/logos/blanco.png')" class="myimg" alt="" v-if="scrolled || window.width <= 992">
              <img :src="url ? require('@/assets/images/logos/blanco.png') : require('@/assets/images/logos/azul.png')" class="myimg" v-else>
            </router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbar">
                <div class="navbar-nav ml-auto mr-0">
                    <router-link class="nav-item nav-link" :to="{ name: 'about' }">{{ lang == 'es' ? 'Acerca de Nosotros' : 'About Us' }}</router-link>
                    <router-link class="nav-item nav-link" :to="{ name: 'experience' }">{{ lang == 'es' ? 'Experiencia Profesional' : 'Professional Experience' }}</router-link>
                    <router-link class="nav-item nav-link" :to="{ name: 'services' }">{{ lang == 'es' ? 'Servicios' : 'Services' }}</router-link>
                    <router-link class="nav-item nav-link" :to="{ name: 'contact' }">{{ lang == 'es' ? 'Contáctenos' : 'Contact us' }}</router-link>
                    <div class="dropdown ml-lg-4">
                      <a class="nav-item nav-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-globe fa-lg"></i>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" style="cursor:pointer;" @click="click('en')"><i class="fa fa-check" v-if="lang != 'en' && lang != 'es' || lang == 'en'"></i> {{ lang == 'es' ? 'Inglés' : 'English' }}</a>
                        <a class="dropdown-item" style="cursor:pointer;" @click="click('es')"><i class="fa fa-check" v-if="lang == 'es'"></i> {{ lang == 'es' ? 'Español' : 'Spanish' }}</a>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>
<script>
export default {
  data() {
    return {
      limitPosition: 0,
      scrolled: false,
      lastPosition: 0,
      window: {
        width: 0,
        height: 0
      },
      url: false,
      lang: window.lang ? window.lang : 'en'
    }
  },
  watch: {
    '$route' (to, from) {
      this.url = to.name == 'index' ? true : false;
    }
  },
  methods: {
    handleScroll() {
      if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
        this.scrolled = true;
        // move up!
      }

      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 20;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    click(lang){
      localStorage.setItem('lang', lang)
      this.$router.go()
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.url = this.$route.name == 'index' ? true : false;
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/navbar.vue